import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import {
    getTextFilterCfg,
    getSelectFilterCfg,
    getEditIconColumn,
    getNumberFilterCfg,
} from '../grid/ColumnHelpers'

import IzraktenisMap from '../karte/IzraktenisMap';
import * as maputils from '../karte/maputils'

import SplitterLayout from 'react-splitter-layout';

import { guiSet } from '../../actions/uiActions'

import Grid from '../grid/Grid'
import BBoxFilterButtonToUrl from '../grid/BBoxFilterButtonToUrl'
import ArchivedFilterButtonToUrl from '../grid/ArchivedFilterButtonToUrl'
import { dzeramaUdensSatecesBaseinsSelected } from '../../actions/dzeramaUdensSatecesBaseiniActions';
import Link from 'redux-first-router-link';
import { Button } from 'reactstrap';

const editIconColumn = getEditIconColumn((row) => (
    {
        type: 'loc_dzerama_udens_sateces_baseins',
        payload: {
            id: row.id
        }
    }
))

const getUrbumsFormatter = (fieldValue) => fieldValue.map((urb, i) =>
    <div key={i} className="badge-column">
        <Link
            to={{
                type: 'loc_urbums',
                payload: {
                    id: urb.urbumi_id
                }
            }}
        >
            {urb.urbumi_id}
        </Link>
    </div>
)

const getPazemesUdenuObjektsFormatter = (fieldValue) => fieldValue.map((puo, i) =>
    <div key={i} className="badge-column">
        <Link
            to={{
                type: 'loc_pazemes_udens_objekts',
                payload: {
                    kods: puo.kods
                }
            }}
        >
            {puo.kods}
        </Link>
    </div>
)

const getAtradneFormatter = (fieldValue, row) => {
    if (!row.urbumi_atradnes_id) return fieldValue
    return (
        <div className="badge-column">
            <Link
                to={{
                    type: 'loc_urbumu_atradne',
                    payload: {
                        id: row.urbumi_atradnes_id
                    }
                }}
            >
                {fieldValue}
            </Link>
        </div>
    )
}

const riskLevelColors = {
    'Zems risks': '#d4edda',
    'Vidējs risks': '#fff3cd',
    'Augsts risks': '#f8d7da'
};

const riskLevelFormatter = (cell) => cell && cell !== '-' ? cell : '-';

const riskLevelStyle = (cell) => {
    const color = riskLevelColors[cell];
    if (!color) return {};
    return { backgroundColor: color, fontWeight: '500' };
};

const getColumns = ({ kodif }) => {
    return [editIconColumn,
        {
            dataField: 'kods',
            text: 'Kods',
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'nosaukums',
            text: 'ŪAS Nosaukums',
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'operators',
            text: 'Operators',
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'q_adm_ters',
            text: 'Administratīvā teritorija',
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'platiba',
            text: 'SB platība, ha',
            width: 120,
            filterCfg: getNumberFilterCfg()
        }, {
            dataField: 'udens_ieguves_vietas',
            text: 'Ūdens ieguves vietas DB nr.',
            sort: false,
            width: 220,
            style: { maxWidth: '220px' },
            formatter: getUrbumsFormatter,
            classes: 'wrap-cell',
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'urbumi_atradnes_geom_nosaukums',
            text: 'Atradne',
            formatter: getAtradneFormatter,
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'pazemes_udens_objekti_kodi',
            text: 'PŪO',
            width: 160,
            style: { maxWidth: '160px' },
            formatter: (cell, row) => getPazemesUdenuObjektsFormatter(row.pazemes_udens_objekti || []),
            classes: 'wrap-cell',
            filterCfg: {
                type: 'autocomplete',
                autocompleteCfg: {
                    remoteSearchViewName: 'dzerama_udens_sateces_baseins_pazemes_udenu_objekti_search'
                }
            }
        }, {
            dataField: 'riska_novertejums',
            text: 'Riska novērtējums',
            formatter: riskLevelFormatter,
            style: riskLevelStyle,
            filterCfg: getSelectFilterCfg(kodif.riskaNovertejums)
        }
    ]
};


class DzeramaUdensSatecesBaseiniSaraksts extends Component {

    constructor(props) {
        super(props)
        this.mapRef = createRef()
    }

    mapPaneSizeChange = (h) => {
        this.props.guiSet('dzerama_udens_sateces_baseini_saraksts_karte_height', h);
    }

    render() {

        const { kodif, dzeramaUdensSatecesBaseini, gui, dzeramaUdensSatecesBaseinsSelected } = this.props
        const { list, selected, loading, count } = dzeramaUdensSatecesBaseini

        const vectorLayerCfgs = {
            dzeramaUdensSatecesBaseini: {
                title: 'Dzeramā ūdens sateces baseini',
                features: list,
                styles: maputils.atradnesStyles,
                tooltipFunc: (feat) => `${feat.get('nosaukums')}`,
                selected: selected,
                legend: maputils.defaultSinglePolygonLegend
            }
        }

        if (!this.columns) {
            this.columns = getColumns({
                kodif
            })
        }

        return (
            <SplitterLayout
                vertical
                percentage
                primaryIndex={1}
                secondaryInitialSize={gui.dzerama_udens_sateces_baseini_saraksts_karte_height}
                onSecondaryPaneSizeChange={this.mapPaneSizeChange}>

                <IzraktenisMap ref={this.mapRef} mapId="dzerama_udens_sateces_baseini_saraksts" vectorLayerCfgs={vectorLayerCfgs} />

                <Grid
                    onRowSelected={dzeramaUdensSatecesBaseinsSelected}
                    loading={loading}
                    selectedId={selected}
                    dataList={list}
                    totalCount={count}
                    columns={this.columns}
                    extraGridProps={{ rowClasses: (row) => row.ir_arhivets ? 'row-archived' : '' }}
                >
                    {this.props.user.tiesibas.includes('SATECES_BASEINI_LABOT') ? (
                        <Link to={{
                            type: 'loc_dzerama_udens_sateces_baseins',
                            payload: {
                                id: 'jauns'
                            }
                        }}>
                            <Button color="primary"><i className="fa fa-plus-circle"></i>&nbsp;&nbsp;Jauns</Button>
                        </Link>
                    ) : null}
                    <BBoxFilterButtonToUrl />
                    <ArchivedFilterButtonToUrl />
                </Grid>

            </SplitterLayout>
        )
    }
}

const mapStateToProps = ({ kodif, dzeramaUdensSatecesBaseini, gui, user }) => {
    return { kodif, dzeramaUdensSatecesBaseini, gui, user }
}

export default connect(mapStateToProps, { dzeramaUdensSatecesBaseinsSelected, guiSet })(DzeramaUdensSatecesBaseiniSaraksts)